import * as moment from 'moment';
import { Staff } from './staff.model';

export interface Schedule {
  objkbn: string;
  objcd: string;
  objnm: string;
  noteid: number;
  sdate: Date;
  edate: Date;
  resultatr: number;
  ttlkbn: string;
  ttlcd: string;
  ttlnm: string;
  address?: string;
  isImage?: boolean;
  tagColor?: [number, number, number];
  upddate: Date;
  odrstfnm?: string;
  sndstfnm?: string;
  ownstfnm?: string;
  odrstfcd?: string;
  sndstfcd?: string;
  displayOption?: {
    readable: boolean;
    writable: boolean;
    isLocked: boolean;
  };
}

// for non stf schedules
export const emptyStaff: Staff = {
  stfcd: '-1',
  name: '（担当者未割り当て）'
}

export enum ResultAtr {
  NONE = 0,
  PLAN = 1,
  EXCUTE = 2,
  CANCEL = 3,
  UPDATE = 4
}

export enum LIMIT_DATE {
  EDATE = '2500-01-01',
  SDATE = '1900-01-01'
}

export class ScheduleRole {
  sched_add: boolean[] = [];
  sched_view: boolean[] = [];
}


export class ScheduleConfig {
  // schedule-display
  isUser: boolean = false;
  isVertical: boolean = true;
  stime: string = '00:00';
  etime: string = '23:59';

  // schedules-data filter

  users?: string[] = [];
  staffs?: string[] = [];
  byResultAtr: ResultAtr[] = [ResultAtr.PLAN];
  //予定のある人のみ表示する
  hasPlanning: boolean = true;

  // setting
  targetDate: Date = new Date();
  private defaultFormat: string = 'DD/MM/YYYY';

  get currentDateString() {
    return moment(this.targetDate).format(this.defaultFormat);
  }

  private getDateTime(time: string = '00:00') {
    return moment(this.currentDateString + ' ' + time, this.defaultFormat + ' HH:mm').toDate();
  }

  constructor() { 
    this.isUser = true;
    this.isVertical = true;
    this.stime = '00:00';
    this.etime = '23:59';
    this.users = [];
    this.staffs = [];
    this.byResultAtr = [];
    this.hasPlanning = false;
    this.targetDate = new Date();
  }

  /**
   * 
   * @param schedules raw schedules
   * @returns filter schedules
   */
  filterSchedule(schedules: ScheduleTimeLine[] = []) {
    if (schedules.length === 0) return schedules;
    // filter
    return schedules.filter((schd) => {
      this.filterByUsers(schd) &&
        this.filterByStaff(schd) &&
        this.filterByTime(schd) &&
        this.filterByResultAtr(schd)
    });

  }

  /**
   * 
   * @param date current date
   * @param isVertical if display vertical
   * @param isUser if user mode
   */
  settingSchedule(date: Date, isVertical: boolean, isUser: boolean) {
    this.targetDate = date;
    this.isVertical = isVertical;
    this.isUser = isUser;
  }

  private filterByResultAtr(schedule: ScheduleTimeLine) {
    if (this.byResultAtr?.length === 0) return true;
    return this.byResultAtr?.some(user => schedule.resultatr === user);
  }

  /**
   * 
   * @param schedule raw schedule
   * @returns filter schedules by user
   */
  private filterByUsers(schedule: ScheduleTimeLine) {
    if (this.users?.length === 0) return true;
    return this.users?.some(user => schedule.objcd === user);
  }

  /**
   * 
   * @param schedule raw schedule
   * @returns filter schedules by staff
   */
  private filterByStaff(schedule: ScheduleTimeLine) {
    if (this.staffs?.length === 0) return true;
    return schedule.odrstfcd === this.staffs || schedule.sndstfcd === this.staffs;
  }

  /**
  * 
  * @param schedule raw schedule
  * @returns filter schedules by time
  */
  private filterByTime(schedule: ScheduleTimeLine) {
    if (!this.stime || !this.etime) return;
    let sdate = this.getDateTime(this.stime);
    let edate = this.getDateTime(this.etime);
    let schdSdate = moment(schedule.sdate).toDate();
    let schdEdate = moment(schedule.edate).toDate();
    return (schdSdate <= sdate && schdEdate >= sdate || schdSdate <= edate && schdEdate >= edate);
  }
}
export interface ScheduleTimeLine extends Schedule {
  indexPadding?: number;
}

export interface Schedule_Paging {
  scheduleList: Schedule[];
  takesRecord?: number;

}

export interface ScheduleField {
  objkbn: string;
  objcd: string;
  objnm: string;
  noteid?: number;
  sdate: Date;
  edate: Date;
  corpcd: string;
  officecd: string;
  blockcd: string;
  subcd: string;
  unitcd: string;
  ttlkbn: string;
  ttlcd: string;
  ttlnm: string;
  notekbn: number;
  resultatr?: number;
  pickupflg?: number;
  lifeflg?: number;
  ownstfcd: string;
  ownstfnm: string;
  ownunitcd: string;
  odrstfcd?: string;
  odrstfnm?: string;
  sndstfcd?: string;
  sndstfnm?: string;
  contents?: string;
  v2contents?: string;
}

export interface ScheduleTitle {
  objcd: string;
  ttlkbn: string;
  ttlcd: string;
  name: string;
}

export interface ButtonTitle {
  pos: string;
  nm: string;
  ckbnid: string;
  compid: string;
  ctype: string;
  funcid: string;
  action: string;
  objcd: string;
  ttlkbn: string;
  ttlcd: string;
  ttlnm: string;
  readable: boolean;
  writable: boolean;
  path: string;
}
